import { graphql } from '@teachino/shared-infrastructure';
import { topicListItemFragment } from './topic-list-item';

export const topicListQuery = graphql(
  `
    query TopicList($folderId: String, $search: String) {
      searchContent(
        contentSearchInput: {
          search: $search
          libraryFolderId: $folderId
          searchType: TOPIC
        }
      ) {
        ... on BaseModel {
          id
          __typename
        }
        ... on TopicInstance {
          position
        }
        ... on Folder {
          id
          ...TopicListItem
        }
      }
    }
  `,
  [topicListItemFragment],
);
